// extracted by mini-css-extract-plugin
export var cardHeader = "_fo-1";
export var contentCard = "_fo-0";
export var headerActions = "_fo-3";
export var reorderHandle = "_fo-5";
export var titleArea = "_fo-2";
export var titleAreaWithHandle = "_fo-4";